import React from 'react';
import { Box, SxProps } from '@mui/material';
import { spaces } from '../../../../assets/styles/themes/tokens';
import useScreenSize from '../../../../utils/useScreenSize';
import useCardDimensions from '../../../../utils/useCardDimensions';

const SearchResultsContainer: React.FC<{ customSx?: SxProps }> = (props) => {
  const { isXsScreen } = useScreenSize();
  const cardDimensions = useCardDimensions();
  
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: isXsScreen ? spaces.sm : spaces.md,
    maxWidth: cardDimensions.desktop.maxWidth,
    marginX: 'auto',
    ...props.customSx,
  }}>
    { props.children }
  </Box>;
};

export default SearchResultsContainer;
